import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import '../CSS/navBar.css';

function NavBar() {
  const [serviceMenuOpen, setServiceMenuOpen] = useState(false);

  const closeServiceMenu = () => {
    setServiceMenuOpen(false);
  };

  return (
    <header className="site-header">
      <nav className="nav" aria-label="Main navigation">
        <Link className="brand" to="/">
          <svg
            className="brand-logo"
            viewBox="0 0 64 48"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M8 10H42V36H25" />
            <path d="M42 18H52C55.6 18 59 21.4 59 25V36H55" />
            <path d="M42 27H56C60.4 27 62 30.2 62 34V36H55" />
            <path d="M8 36H13" />
            <path d="M25 36H43" />
            <path d="M14 16H25" />
            <path d="M10 22H25" />
            <path d="M5 28H23" />
            <path d="M10 34H23" />
            <circle cx="19" cy="36" r="6" />
            <circle cx="49" cy="36" r="6" />
            <path d="M47 30H51" />
          </svg>
          Emmapro Logistix
        </Link>
        <div className="nav-links">
          <div
            className={`nav-item service-nav${serviceMenuOpen ? ' is-open' : ''}`}
            onMouseEnter={() => setServiceMenuOpen(true)}
            onMouseLeave={closeServiceMenu}
          >
            <NavLink className="service-tab" to="/" end>
              Service
            </NavLink>
            <div className="service-menu" aria-label="Service options">
              <Link to="/services/owner-operator" onClick={closeServiceMenu}>
                Owner operator
              </Link>
              <Link
                to="/services/small-fleet-carrier-dispatch-support"
                onClick={closeServiceMenu}
              >
                Carrier dispatch support
              </Link>
              <Link to="/services/dedicated-lanes-routes" onClick={closeServiceMenu}>
                Dedicated lanes
              </Link>
              <Link to="/services/over-the-road" onClick={closeServiceMenu}>
                Over-the-Road
              </Link>
            </div>
          </div>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </div>
      </nav>
    </header>
  );
}

export default NavBar;
